import React from "react";

/** Pied de carte : mention à gauche, signature « ESPOAR · Caf 974 » à droite (masquable). */
const PiedCarte = ({ children, signature = true }) => (
  <div className="pied-carte">
    <span>{children}</span>
    {signature && <span className="signature">ESPOAR · Caf 974</span>}
  </div>
);

export default PiedCarte;
